import { useState, useContext, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import "../../css/common.module.css";
import "../../css/Header.css";
import { LinkContainer } from "react-router-bootstrap";
import Logo from '../../images/IDSLogo.png';
import KeyHandler from "../../components/KeyHandler";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../../utils/FetchUtil";
import { emptyCache } from "../../utils/helper.js";

function Header() {
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
	const [showAdmin, setShowAdmin] = useState(false);
	const [showDelegate, setShowDelegate] = useState(false);
	const [showSetting, setShowSetting] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const [error, setError] = useState("");

	const { t, i18n } = useTranslation();
	FetchUtil.setUserLanguage(i18n, userCtx);

	const showAdminDropdown = (e) => {
		setShowAdmin(true);
		setShowSetting(false);
	}
	const handleAdminMenuToggle = (e) => {
		setShowAdmin(!showAdmin);
	}
	const showSettingDropdown = (e) => {
		setShowSetting(true);
		setShowAdmin(false);
	}
	const handleSettingMenuToggle = (e) => {
		setShowSetting(!showSetting);
	}
	const handleScroll = () => {
		const offset = window.scrollY;
		if (offset > 250) {
			setShowAdmin(false);
			setShowSetting(false);
			setShowDelegate(false);
			setIsScrolled(true);
		} else {
			setIsScrolled(false);
		}
	}
	useEffect(() => {
		if (!userCtx.isAuthenticated) {
			navigate("/");
		}
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleLogOffClick = event => {
		invokeLogOff();
	};

	function invokeLogOff() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ "source": "web" }),
		};

		try {
			FetchUtil.fetchAPI("Logoff", "/Service/UserService/Logoff", requestOptions, logoffSuccess, logoffFail);
		} catch (error) {
			setError(error.message);
			navigate("/", {
				state: {
					errorMessage: t("error.error") + " " + error.message,
				},
			});
		}
	}
	function openLogoff() {
		let logoutWindow = window.open("https://idecisionsciences.awsapps.com/start#/signout", "Application Logout", "width=100,height=100");
		if (logoutWindow) {
			let timeoutVar = setTimeout(
				function() {
					logoutWindow.close();
				}
					.bind(this),
				500
			);
		}
	}

	function resetContext() {
		userCtx.addUserName("");
		userCtx.addLoggedInUserId("");
		userCtx.addRole("");
		userCtx.addIsAuthenticated(false);
		userCtx.clearStorage();
		userCtx.addEnabledMFA(0);
	}
	function logoffFail(redirect) {
		openLogoff();
		emptyCache();
		resetContext();
		navigate("/", {
			state: {
				errorMessage: "Logout failed.",
			},
		});
	}

	function logoffSuccess(responseData) {
		openLogoff();
		emptyCache();
		resetContext();
		let logOffResponse;
		if (responseData) {
			logOffResponse = responseData.logOffResponse;
			if (logOffResponse && logOffResponse.errorCode === "0") {

				navigate("/", {
					state: {
						errorMessage: "",
					},
				});
			} else if (logOffResponse && logOffResponse.errorCode === "114") {
				setError(t("error.error") + " " + logOffResponse.errorMessage);
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (logOffResponse) {
				setError(t("error.error") + " " + logOffResponse.errorMessage);
				navigate("/", {
					state: {
						errorMessage: t("error.error") + " " + logOffResponse.errorMessage,
					},
				});
			} else {
				navigate("/", {
					state: {
						errorMessage: t("error.error"),
					},
				});
			}
		} else {
			setError(t("error.error"));
			navigate("/", {
				state: {
					errorMessage: t("error.error"),
				},
			});
		}
	}
	const showDelegateDropdown = (e) => {
		setShowAdmin(true);
		setShowDelegate(!showDelegate);
		setShowSetting(false);
	}
	const handleDelegateMenuToggle = (e) => {
		setShowDelegate(!showDelegate);
	}
	return (
		<>
			<Navbar bg="dark" variant="light"
				expand="lg"
				className={isScrolled ? " scrolled mybgcolor " : " mybgcolor "}
			>
				<Navbar.Brand className="nav-item text-light px-2"><img alt="" src={Logo} className="d-inline-block align-top logo" />{' '}</Navbar.Brand>
				<div className="px-2"></div>

				<Navbar.Toggle aria-controls="basic-navbar-menu" />
				<Navbar.Collapse id="basic-navbar-menu" className="navbar-menu">
					<Nav className="ml-auto">
						<NavLink to="/pages/landing" className=" nav-link text-light navlink-bg"><span className="fa fa-home"> </span>
							{t("header.home")}
						</NavLink>

						{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
							<NavDropdown title={<span className=" text-light nav-link"><span className="fa fa-gears"> </span>
								{t("header.admin")}
							</span>} id="admin-nav-dropdown"
								alignRight show={showAdmin}
								onMouseEnter={showAdminDropdown}
								onClick={handleAdminMenuToggle}
								renderMenuOnMount={true}
								onToggle={handleAdminMenuToggle}
								className="nav-link text-light navlink-bg">
								<span className="navdropdown-menu">
									<LinkContainer to="/pages/users">
										<NavDropdown.Item className="">
											{t("header.admin.users")}
										</NavDropdown.Item>
									</LinkContainer>
									{(userCtx.role === "SiteAdmin") ?
										<LinkContainer to="/pages/companies">
											<NavDropdown.Item className="">
												{t("header.admin.companies")}
											</NavDropdown.Item>
										</LinkContainer>
										: null}
									{(userCtx.role === "SiteAdmin") ?
										<LinkContainer to="/pages/subsidiaries">
											<NavDropdown.Item className="">
												{t("header.admin.subsidiary")}
											</NavDropdown.Item>
										</LinkContainer>
										: null}
									{(userCtx.role === "SiteAdmin") ?
										<LinkContainer to="/pages/partners">
											<NavDropdown.Item className="">
												{t("header.admin.partner")}
											</NavDropdown.Item>
										</LinkContainer>
										: null}
									<LinkContainer to="/pages/compsurveys">
										<NavDropdown.Item className="">
											{t("header.admin.comsurv")}
										</NavDropdown.Item>
									</LinkContainer>
									<LinkContainer to="/pages/departments">
										<NavDropdown.Item className="">
											{t("header.admin.dept")}
										</NavDropdown.Item>
									</LinkContainer>
									<LinkContainer to="/pages/locations">
										<NavDropdown.Item className="">
											{t("header.admin.loc")}
										</NavDropdown.Item>
									</LinkContainer>
									<LinkContainer to="/pages/commodity">
										<NavDropdown.Item className="">
											{t("header.admin.commodity")}
										</NavDropdown.Item>
									</LinkContainer>
									<LinkContainer to="/pages/comproducts">
										<NavDropdown.Item className="">
											{t("header.admin.comprod")}
										</NavDropdown.Item>
									</LinkContainer>
									<LinkContainer to="/pages/surveyproducts">
										<NavDropdown.Item className="">
											{t("header.admin.surveyprod")}
										</NavDropdown.Item>
									</LinkContainer>
									{(userCtx.role === "SiteAdmin") ?
										<>
											<NavDropdown.Divider />
											<NavDropdown title={<span className="dropdown-item">
												{t("header.admin.delegate")}
											</span>} id="delegate-nav-dropdown"
												alignRight show={showDelegate}
												onMouseEnter={showDelegateDropdown}
												onClick={handleDelegateMenuToggle}
												renderMenuOnMount={false}
												onToggle={handleDelegateMenuToggle}
												className="navsub-menu"
											>
												<LinkContainer to="/pages/partnerDelegateDisplay">
													<NavDropdown.Item className="">
														{t("header.admin.supply-chain.display")}
													</NavDropdown.Item>
												</LinkContainer>
												<LinkContainer to="/pages/partnerDelegateEdit">
													<NavDropdown.Item className="">
														{t("header.admin.supply-chain.edit")}
													</NavDropdown.Item>
												</LinkContainer>
												<LinkContainer to="/pages/partnerDelegate">
													<NavDropdown.Item className="">
														{t("header.admin.partnerDelegate")}
													</NavDropdown.Item>
												</LinkContainer>
											</NavDropdown>
										</>
										: null}
								</span>
							</NavDropdown>
							: null}
					</Nav>
				</Navbar.Collapse>


				<Navbar.Collapse id="basic-navbar-logoff" className="navbar-logoff">
					<Nav className="ml-auto">
						<NavDropdown title={<span className=" text-light nav-link"><span className="fa fa-cog"> </span>
							{t("header.settings")}
						</span>} id="setting-nav-dropdown"
							alignRight show={showSetting}
							onMouseEnter={showSettingDropdown}
							onClick={handleSettingMenuToggle}
							renderMenuOnMount={true}
							onToggle={handleSettingMenuToggle}
							className="nav-link text-light navlink-bg">
							<a href="https://idecisionsciences.awsapps.com/start#/devices" target='_blank' style={{ marginLeft: "10px" }}>
								<span style={{ color: "black", fontSize: "16px", textAlign: "center" }}>
									{t("header.settings.manageMFA")}
								</span>
							</a>
						</NavDropdown>
					</Nav>
					<Nav className="ml-auto">
						<NavLink className=" nav-link text-light navlink-bg" onClick={handleLogOffClick}><span className="fa fa-sign-out"> </span>
							{t("header.logoff")}
						</NavLink>
					</Nav>
				</Navbar.Collapse>
				<KeyHandler />
			</Navbar>
			<div className={isScrolled ? " navbar-banner navbar-light bg-success scrolled-banner" : " navbar-banner navbar-light bg-success"}>
				<Navbar.Brand className="nav-item text-light px-8 fw-semibold">{t("header.hello")} {userCtx.userName}</Navbar.Brand>
			</div>
		</>
	);
}

export default Header;
